var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"coconala-icon",class:( _obj = {}, _obj[("-" + _vm.name)] = true, _obj[("-is-" + _vm.color)] = !!_vm.color, _obj ),style:({ 'font-size': _vm.size })})}
var staticRenderFns = []

export { render, staticRenderFns }